import baseWs from './baseWs'
import _ from 'lodash';
//import axios from 'axios';

export function fetchGenericScreenInfo(screenId) {
	return baseWs.post('/api/services/app/genericScreen/FetchScreenInfo', {
		screenId: screenId
	})
	.then(res => {
		return res;
	})
	.catch(err => {
		if (!_.isEmpty(err.response)) {
			console.log('Error')
		}
		console.log('Error getting screen info: ' + err);
		throw err;
	});
}